import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: null,
      myChart: null,
      showLegend: false,
      smallLabelData: [],
      labelData: []
    };
  },
  methods: {
    setLegendShow: function setLegendShow(val) {
      this.showLegend = val;

      if (val) {
        this.option.legend.data = this.labelData;
      } else {
        this.option.legend.data = this.smallLabelData;
      }

      this.myChart.setOption(this.option);
    },
    //selectedObj 是否有自定义不显示的因子 setIndex要展示前几项
    initBarChart: function initBarChart() {
      var _this = this;

      var xAxisData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var yAxisData1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '潮高(cm)';
      var setIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;
      var color = ['#0090FF', '#36CE9E', '#00d6ff', '#045e7e', '#8B5CFF', '#fdd000'];
      var selected = {};
      var normalData = [];
      yAxisData1.forEach(function (item) {
        selected[item.title] = true;
        normalData.push(item.title);
      });

      if (yAxisData1.length <= setIndex) {
        this.showIcon = false;
      }

      this.labelData = [].concat(normalData);
      this.smallLabelData = _toConsumableArray(normalData.splice(0, setIndex));

      var hexToRgba = function hexToRgba(hex, opacity) {
        var rgbaColor = '';
        var reg = /^#[\da-f]{6}$/i;

        if (reg.test(hex)) {
          rgbaColor = "rgba(".concat(parseInt('0x' + hex.slice(1, 3)), ",").concat(parseInt('0x' + hex.slice(3, 5)), ",").concat(parseInt('0x' + hex.slice(5, 7)), ",").concat(opacity, ")");
        }

        return rgbaColor;
      };

      var series = [];
      yAxisData1.forEach(function (item, index) {
        series.push({
          name: item.title,
          type: 'line',
          smooth: false,
          showSymbol: false,
          label: {
            show: false
          },
          symbolSize: 8,
          zlevel: 3,
          lineStyle: {
            normal: {
              color: color[index % 6],
              shadowBlur: 3,
              shadowColor: hexToRgba(color[index % 6], 1) // shadowOffsetY: 8

            }
          },
          // areaStyle: {
          //   normal: {
          //     color: new echarts.graphic.LinearGradient(
          //       0,
          //       0,
          //       0,
          //       1,
          //       [
          //         {
          //           offset: 0,
          //           color: hexToRgba(color[index%6], 0.3)
          //         },
          //         {
          //           offset: 1,
          //           color: hexToRgba(color[index%6], 0.1)
          //         }
          //       ],
          //       false
          //     ),
          //     // shadowColor: hexToRgba(color[index%6], 0.1),
          //     // shadowBlur: 10
          //   }
          // },
          data: item.data
        });
      });
      this.option = {
        color: color,
        legend: {
          data: this.showLegend ? this.labelData : this.smallLabelData,
          show: true,
          top: '0%',
          left: '5%',
          selected: selected,
          textStyle: {
            fontSize: 14,
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'axis',
          // formatter: function(params) {
          //   let html = ''
          //   params.forEach((v) => {
          //     console.log(v)
          //     html += `<div style="color: #fff;font-size: 14px;line-height: 24px">
          //       <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
          //       color[v.componentIndex]
          //     };"></span>
          //       ${v.seriesName}.${v.name}
          //       <span style="color:${
          //       color[v.componentIndex]
          //     };font-weight:700;font-size: 18px">${v.value}</span>
          //       万元`
          //   })
          //
          //   return html
          // },
          extraCssText: 'background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#ffffff',
              shadowColor: 'rgba(225,225,225,1)',
              shadowBlur: 5
            }
          }
        },
        grid: {
          // top: 100,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9'
            }
          },
          data: xAxisData
        }],
        yAxis: [{
          type: 'value',
          name: title,
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          nameTextStyle: {
            color: '#fff',
            fontSize: 12 // lineHeight: 40

          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E9E9E9'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }],
        series: series
      };
      this.chart = this.$refs.chartTide;
      this.myChart = this.$echarts.init(this.chart);
      this.myChart.setOption(this.option);
      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    }
  }
};